import classNames from 'classnames';
import s from './InputDate.module.scss';
import { ChangeEvent } from 'react';
import CheckIcon from '@/shared/assets/icons/check.svg';
import WarningIcon from '@/shared/assets/icons/warning.svg';
import { IMaskInput } from 'react-imask';

interface InputProps {
  label: string;
  className?: string;
  placeholder?: string;
  error: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement> | string) => void;
  disabled?: boolean;
  isSubmitted?: boolean;
  baseAddon?: boolean;
  onBlur?: () => void;
  name?: string;
  inputId?: string;
  autoComplete?: string;
}

export const InputDate = (props: InputProps) => {
  const {
    className,
    label,
    placeholder,
    error,
    value = '',
    onChange,
    disabled,
    isSubmitted,
    baseAddon = true,
    onBlur,
    name,
    inputId,
    autoComplete = 'off',
  } = props;

  const mods = {
    [s.disabled]: disabled,
    [s.isError]: !!error,
  };

  return (
    <div className={classNames(s.Input, mods, [className])}>
      <label className={s.label} htmlFor={(inputId ?? label) || undefined}>
        {label}
      </label>
      <div className={s.wrapper}>
        <IMaskInput
          className={classNames(s.input, { [s.baseAddon]: baseAddon }, [className])}
          value={value}
          mask={Date}
          pattern={'d.m`.`Y'}
          overwrite={true}
          autofix={'pad'}
          onAccept={(value) => onChange(value)}
          placeholder={placeholder}
          type={'text'}
          disabled={disabled}
          id={(inputId ?? label) || undefined}
          onBlur={onBlur}
          name={name}
          autoComplete={autoComplete}
        />

        {baseAddon && isSubmitted && (
          <div className={s.status}>
            {error ? <WarningIcon className={s.warning} /> : <CheckIcon className={s.check} />}
          </div>
        )}
      </div>
      {error && error.trim().length > 0 && <span className={s.error}>{error}</span>}
    </div>
  );
};
